import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {useNavigate} from 'react-router-dom'; // useNavigate 가져오기
import actionTypes from "../../../constants/actionTypes";
import Menu from "../../../components/header/Menu";
import CommonPage from "./CommonPage";

const Header = ({isMenu, loginData, menuOn, loginCheck, setInfo, menuData, name}) => {
    const navigate = useNavigate(); // useNavigate 훅 사용

    useEffect(() => {
        handleChangeBlockData();
    }, [loginData.isAuth]); // loginData.isLogin이 변경될 때마다 실행

    const handleChangeBlockData = () => {
        menuOn();
        if (!loginData.isAuth) {
            loginCheck();

        } else if (loginData.isLogin && !loginData.isInfo) {
            setInfo(); // isInfo 값을 true로 설정
            navigate('/info-input'); // useNavigate로 경로 변경
        }
    };

    return (
        <>
            <Menu menuList={menuData} loginData={loginData} name={name}/>
            <CommonPage menuList={menuData}/>
        </>
    );
};

const mapStateToProps = state => ({
    menuData: state.menu.menuData,
    isMenu: state.menu.isMenu,
    loginData: state.login,
});

const mapDispatchToProps = dispatch => ({
    menuOn: () => dispatch({type: actionTypes.MENU_ON}),
    loginCheck: () => dispatch({type: actionTypes.LOGIN_CHECK}),
    setInfo: () => dispatch({type: actionTypes.LOGIN_INFO_APPROVAL}) // 액션 디스패치 추가
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);